import { render, staticRenderFns } from "./detalhesEmpresas.vue?vue&type=template&id=84bef650&scoped=true&"
import script from "./detalhesEmpresas.vue?vue&type=script&lang=js&"
export * from "./detalhesEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./detalhesEmpresas.vue?vue&type=style&index=0&id=84bef650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bef650",
  null
  
)

export default component.exports